import { faClose, faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useCallback } from 'react'

import { useTranslation } from 'services/i18n'
import { useConversationSearch } from 'stores/useConversationSearchStore'

import type { ChangeEventHandler, FC } from 'react'

export const ConversationHistorySearchInput: FC = () => {
  const { t } = useTranslation()

  const { searchValue, setInputValue, clearInputValue }
    = useConversationSearch()

  const handleSetInputValue: ChangeEventHandler<HTMLInputElement> = useCallback(
    ({ target }) => setInputValue(target.value),
    [setInputValue],
  )

  return (
    <div className="mb-1 w-full">
      <label
        className="mx-2 flex w-[calc(100%-16px)] items-center gap-x-2 rounded border border-default bg-default px-2 transition-colors focus-within:border-input-active hover:border-dark focus-within:hover:border-input-active"
        htmlFor="conversation-list-search"
      >
        <FontAwesomeIcon
          className="text-subdued"
          icon={faMagnifyingGlass}
          size="sm"
        />
        <input
          className="h-8 w-full border-0 bg-transparent text-sm text-default shadow-none outline-none placeholder:text-subdued"
          type="text"
          id="conversation-list-search"
          onChange={handleSetInputValue}
          aria-label={t('conversation_history.search_in_conversation_description')}
          placeholder={t('conversation_history.search_in_conversation')}
          value={searchValue}
        />
        {searchValue.length > 0 && (
          <FontAwesomeIcon
            type="button"
            className="cursor-pointer text-subdued"
            role="button"
            aria-label={t('conversation_history.search_in_conversation_clear')}
            icon={faClose}
            size="sm"
            onClick={clearInputValue}
          />
        )}
      </label>
    </div>
  )
}
